
import React from 'react';
import { Button } from '@/components/ui/button';
import { Edit } from 'lucide-react';
import SymptomsEdit from '../SymptomsEdit';
import { SYMPTOMS } from '@/data/symptoms';

interface SymptomsSectionProps {
  data: {
    selectedSymptoms: string[];
  };
  editMode: string | null;
  onEditToggle: (section: string) => void;
  onSave: (section: string, data: any) => void;
}

const SymptomsSection: React.FC<SymptomsSectionProps> = ({ 
  data, 
  editMode, 
  onEditToggle, 
  onSave 
}) => {
  // Function to get symptom label by ID
  const getSymptomLabel = (symptomId: string): string => {
    if (symptomId === 'none') return 'No symptoms reported';
    const symptom = SYMPTOMS.find(s => s.id === symptomId);
    return symptom ? symptom.label : symptomId;
  };

  return (
    <>
      {editMode === 'symptoms' ? (
        <SymptomsEdit 
          data={data} 
          onSave={(data) => onSave('symptoms', data)}
          onCancel={() => onEditToggle('symptoms')}
        />
      ) : (
        <div className="space-y-4">
          <h3 className="font-medium">Symptoms you're experiencing:</h3>
          <ul className="list-disc pl-5 space-y-1">
            {data.selectedSymptoms.map((symptomId, index) => (
              <li key={index}>
                {getSymptomLabel(symptomId)}
              </li>
            ))}
          </ul>
          <Button
            variant="outline"
            size="sm"
            className="mt-2"
            onClick={() => onEditToggle('symptoms')}
          >
            <Edit className="h-4 w-4 mr-2" />
            Edit Symptoms
          </Button>
        </div>
      )}
    </>
  );
};

export default SymptomsSection;
